function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.48667 9.59881C8.20344 9.59943 7.92896 9.48787 7.71088 9.28347L0.437897 2.42841C0.190353 2.1957 0.0346815 1.86129 0.00512927 1.49876C-0.024423 1.13623 0.0745647 0.775265 0.280316 0.495281C0.486067 0.215297 0.781727 0.0392264 1.10226 0.00580147C1.42278 -0.0276235 1.74192 0.0843354 1.98947 0.317049L8.48667 6.45919L14.9839 0.536412C15.1079 0.422528 15.2505 0.337481 15.4037 0.286162C15.5568 0.234843 15.7174 0.218262 15.8762 0.237373C16.0351 0.256484 16.189 0.310908 16.3292 0.397521C16.4693 0.484133 16.593 0.601224 16.693 0.742064C16.804 0.883033 16.8881 1.04841 16.94 1.22784C16.9918 1.40727 17.0104 1.59688 16.9945 1.7848C16.9785 1.97272 16.9285 2.15489 16.8474 2.3199C16.7663 2.48491 16.656 2.6292 16.5233 2.74374L9.25033 9.36574C9.02598 9.53782 8.7571 9.61988 8.48667 9.59881Z",
  fill: "#AEAEAE"
});

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.6d4945af.svg";
export { ForwardRef as ReactComponent };